import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import ButtonComponent from "@components/Theme/Button/Button"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useState} from "react"

import styles from "./FeaturesNavigationButton.module.scss"
type Props = {
	data: AdvancedSideAssetMainContent
	active: boolean
	simple?: boolean
	id: number
	onClick?: (id: number) => void
}

const FeaturesNavigationButton = (props: Props) => {
	const [isHovered, setIsHovered] = useState(false)

	const setHovered = (cond: boolean) => {
		setIsHovered(cond)
	}

	const image =
		isHovered || props.active ? props.data.preview : props.data.preview

	return (
		<ButtonComponent
			buttonType={"unstyled"}
			className={`${styles.featuresButton} ${
				props.active || isHovered ? styles.active : ""
			} ${props.simple ? styles.simple : styles.default}`}
			id={`${props.id}`}
			onClick={() => props?.onClick?.(props.id)}
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
		>
			{image && (
				<NewResponsiveImage
					containerClassName={styles.image}
					imageClassName={styles.imageClassname}
					style={
						props.active || isHovered
							? {}
							: {
									transition: " 0.3s",
							  }
					}
					{...image}
					alt={props.data.title ?? image?.alt}
				/>
			)}
			<Typography
				className={`${styles.featuresTitleButton} ${
					props.active || isHovered ? styles.active : ""
				} `}
				content={props.data.title}
				fontWeight={
					props.active || isHovered ? 600 : props.simple ? 600 : 600
				}
				variant={Variant.Title}
				size={Size.M}
			/>
		</ButtonComponent>
	)
}

export default FeaturesNavigationButton
